import React from 'react';
import PageNotFound from './PageNotFound';
import { useEventInfo } from '@shared/utils/eventInfo';

export interface PageNotFoundWrapperProps {
  eventHandle: string;
}

export const PageNotFoundWrapper: React.FC<PageNotFoundWrapperProps> = props => {
  const { eventInfo, loading } = useEventInfo();

  if (!loading && !eventInfo?.eventId) {
    return <PageNotFound />;
  }

  return <>{props.children}</>;
};
